var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-thumb",domProps:{"innerHTML":_vm._s(_vm.document.thumb)},on:{"click":function($event){$event.preventDefault();return _vm.openFile.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }